import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Alert, Col, Form, Input, Modal, Row, Spin } from 'antd';

// Actions
import { onEditUser } from '../../data/auth/actions';
// Constants
import { MODAL_SIZES } from '../../constants/modal';
import { getUserCompany, getUserEmail, getUserName, getUserSurName } from '../../data/auth/selectors';

class EditUserModal extends PureComponent {
    handleSubmit = () => {
        const { form } = this.props;

        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const { msgs, onEditUser, userId } = this.props;

            onEditUser(userId, values).catch(() => {
                form.setFieldsValue({
                    hasError: msgs.homes.editHomeError
                });
            });
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const {
            form,
            isShown,
            isLoading = false,
            msgs,
            onCancel,
            userName,
            userSurName,
            email,
            company,
        } = this.props;

        const { getFieldValue, getFieldDecorator } = form;
        return (
            <Modal
                key="admin-auth-user-edit"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.auth.editProfile}
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.auth.emailLabel}>
                                    <Input value={email} type="text" readOnly disabled />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.auth.firstName}>
                                    {getFieldDecorator('name', {
                                        initialValue: userName,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label={msgs.auth.lastName}>
                                    {getFieldDecorator('surename', {
                                        initialValue: userSurName,
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item label='Company'>
                                    {getFieldDecorator('company', {
                                        initialValue: company,
                                    })(<Input type="text" />)}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    state => ({
        isLoading: state.auth.getIn(['editModal', 'isLoading']),
        userId: state.auth.getIn(['user', 'data', 'id']),
        userName: getUserName(state),
        userSurName: getUserSurName(state),
        email: getUserEmail(state),
        company: getUserCompany(state),
        isShown: state.auth.getIn(['editModal', 'isShown'])
    }),
    {
        onEditUser
    }
)(Form.create()(EditUserModal));
